// import { initializeApp } from "firebase/app";
// import { getStorage } from "firebase/storage";

// const firebaseConfig = {
//   apiKey: "AIzaSyDJ1xA5synaP0blx0mTtF6nbUUgEev1cu8",
//   authDomain: "new-project-b9ff2.firebaseapp.com",
//   databaseURL: "https://new-project-b9ff2-default-rtdb.firebaseio.com",
//   projectId: "new-project-b9ff2",
//   storageBucket: "new-project-b9ff2.appspot.com",
//   messagingSenderId: "1038340637707",
//   appId: "1:1038340637707:web:22558cedfd9d0b96f3330e",
// };

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC96HY7kb3-dZ0c57BOJ_NLATaUIPmwSAI",
  authDomain: "getgeek-7c6f1.firebaseapp.com",
  projectId: "getgeek-7c6f1",
  storageBucket: "getgeek-7c6f1.appspot.com",
  messagingSenderId: "467144740834",
  appId: "1:467144740834:web:467ef062ff8332949e73bb",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
